import { render, staticRenderFns } from "./addConfig.vue?vue&type=template&id=21eea2e2&scoped=true&"
import script from "./addConfig.vue?vue&type=script&lang=js&"
export * from "./addConfig.vue?vue&type=script&lang=js&"
import style0 from "./addConfig.vue?vue&type=style&index=0&id=21eea2e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eea2e2",
  null
  
)

export default component.exports